import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import useRedirect from 'src/hooks/useRedirect';

const ManageProductsHeader = () => {
  const { getUrl, redirect } = useRedirect();
  const { t } = useTranslation();

  const handleBackToCatalogs = () => {
    const marketplaceUrl = getUrl('catalogMarketplace');
    redirect(marketplaceUrl, false, false);
  };

  return (
    <nav className="flex items-center pt-1 flex-wrap">
      <div className="flex-grow flex justify-center">
        <Button color="info" onClick={handleBackToCatalogs}>
          {t('Back to Catalogs')}
        </Button>
      </div>
    </nav>
  );
};

export default ManageProductsHeader;
